import { Divider, InformationCard } from '@yes.technology/react-toolkit'
import React, { useCallback, useContext, useMemo } from 'react'
import Iframe from 'shared/components/Iframe'
import { useIframe } from 'shared/hooks'
import { SelectAndLinkContext } from 'site/Renderer/components/SelectAndLink/SelectAndLinkContextRef'
import {
  CardContent,
  cardStyle,
  CardWrapper,
  FullScreenWrapper,
  IframeWrapper
} from './SitemodelModal.styles'

type SitemodelModalProps = {
  title: React.ReactNode
  targetSitemodel?: string
  searchParams?: Record<string, string>
  completeURL?: string
  onClose: () => void
  zIndex?: number
  guardCloseWhileSelectAndLinkOpen?: boolean
}

function SitemodelModal({
  title,
  targetSitemodel,
  searchParams,
  completeURL,
  onClose,
  zIndex,
  guardCloseWhileSelectAndLinkOpen = true
}: SitemodelModalProps) {
  const selectAndLinkContext = useContext(SelectAndLinkContext)

  const handleClose = useCallback(() => {
    if (guardCloseWhileSelectAndLinkOpen && selectAndLinkContext?.isOpen) {
      return
    }

    onClose()
  }, [guardCloseWhileSelectAndLinkOpen, selectAndLinkContext?.isOpen, onClose])

  const iframeUrl = useMemo(() => {
    const url = new URL(window.origin)
    if (targetSitemodel) url.pathname = targetSitemodel
    url.search = new URLSearchParams(searchParams).toString()

    return url.toString()
  }, [searchParams, targetSitemodel])

  const { iframeAttributes } = useIframe({
    origin: completeURL || iframeUrl,
    src: completeURL || iframeUrl,
    returnOnFinishedInteraction: false
  })

  return (
    <FullScreenWrapper zIndex={zIndex}>
      <CardWrapper>
        <InformationCard
          title={title}
          isOpen
          close={handleClose}
          style={cardStyle}
          hideHeader={false}
        >
          <Divider
            heightClass='small'
            color='gray'
            style={{ margin: '16px 0' }}
          />
          <CardContent>
            {iframeAttributes && (
              <IframeWrapper>
                <Iframe
                  key={iframeAttributes.src}
                  {...iframeAttributes}
                  height={undefined}
                  style={{
                    flex: 1,
                    minHeight: 0,
                    width: '100%',
                    height: '100%'
                  }}
                />
              </IframeWrapper>
            )}
          </CardContent>
        </InformationCard>
      </CardWrapper>
    </FullScreenWrapper>
  )
}

export default SitemodelModal
